export default {
    url: '/list',
    template: '<forms-settings-formcategories-list></forms-settings-formcategories-list>'
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/forms/settings/formcategories/list/index.js